import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '../i18n'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import ListingView from '../views/ListingView.vue'
import ServiceView from '../views/ServiceView.vue'
import ResourcesView from '../views/ResourcesView.vue'
import ContactView from '../views/ContactView.vue'
import DetailView from '../views/DetailView.vue'
import ArticleView from '../views/ArticleView.vue'
import NotFoundView from '../views/NotFoundView.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', name: 'home', component: HomeView },
    { path: '/about', name: 'about', component: AboutView },
    { path: '/solutions', name: 'solutions', component: ListingView, props: { module: 'SOLUTION' } },
    { path: '/products', name: 'products', component: ListingView, props: { module: 'PRODUCT' } },
    { path: '/cases', name: 'cases', component: ListingView, props: { module: 'CASE' } },
    { path: '/service', name: 'service', component: ServiceView },
    { path: '/resources', name: 'resources', component: ResourcesView },
    { path: '/contact', name: 'contact', component: ContactView },
    { path: '/articles/kitchen-design', name: 'article-design', component: ArticleView },
    { path: '/detail/:module/:id', name: 'detail', component: DetailView, props: true },
    { path: '*', name: 'not-found', component: NotFoundView }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.afterEach(to => {
  const key = { home: 'home', about: 'about', solutions: 'solutions', products: 'products', cases: 'cases', service: 'service', resources: 'resources', contact: 'contact', detail: 'detail', 'article-design': 'article' }[to.name] || 'missing'
  document.title = `${i18n.t(`routes.${key}`)} | ${i18n.t('routes.suffix')}`
})

export default router
